import {createAction, handleActions} from 'redux-actions';
import {takeLatest} from 'redux-saga/effects';

import createRequestSaga, {createRequestActionTypes} from '../../api/createRequestSaga';
import * as dashboardAPI from '../../api/admin/dashboard';

const INITIALIZE = 'dashboard/INITIALIZE';

const CHANGE_FIELD = 'dashboard/CHANGE_FIELD';

const [READ_COMMON_DASHBOARD, READ_COMMON_DASHBOARD_SUCCESS, READ_COMMON_DASHBOARD_FAILURE] = createRequestActionTypes('dashboard/READ_COMMON_DASHBOARD');

export const initialize = createAction(INITIALIZE);

export const changeField = createAction(
    CHANGE_FIELD,
    ({ name, value }) => ({ name, value })
);

export const readCommonDashboard = createAction(
    READ_COMMON_DASHBOARD,
    ({ date_range }) => ({ date_range })
);

const readCommonDashboardSaga = createRequestSaga(READ_COMMON_DASHBOARD, dashboardAPI.readCommonDashboard);

export function* dashboardSaga() {
    yield takeLatest(READ_COMMON_DASHBOARD, readCommonDashboardSaga);
}

const initialState = {
    date_range: 'today',
    commonResponse: null,
    commonError: null
};

const dashboard = handleActions(
    {
        [INITIALIZE]: () => initialState,
        [CHANGE_FIELD]: (state, { payload: { name, value }} ) => ({
            ...state,
            [name]: value
        }),
        [READ_COMMON_DASHBOARD_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            commonResponse: response.data,
            commonError: null
        }),
        [READ_COMMON_DASHBOARD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            commonResponse: null,
            commonError: error
        })
    },
    initialState
);

export default dashboard;
